/* eslint-disable max-len */
// noinspection CssUnusedSymbol

import {COMMON_PDF_CSS} from './common-report-css';

// language=CSS
export const CONSUMER_PDF_CSS = COMMON_PDF_CSS + `
  /*! Consumer CSS Fragment */
  body {
    font-size: 0.75rem;
  }

  .col-10, .col-12, .col-2, .col-3, .col-4, .col-6, .col-8,
  .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1,
  .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1,
  .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1 {
    position: relative;
    width: 100%;
  }

  .col, .col-sm, .col-md, .col-lg,
  [class*=col-sm-].col-md,
  [class*=col-sm-].col-lg,
  [class*=col-md-].col-lg,
  [class*=col-sm-][class*=col-md-].col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .col-1, .col-sm-1, .col-md-1, .col-lg-1,
  [class*=col-sm-].col-md-1,
  [class*=col-].col-md-1,
  [class*=col-md-].col-lg-1,
  [class*=col-].col-lg-1,
  [class*=col-sm-][class*=col-md-].col-lg-1 {
    flex: 0 0 8% !important;
    max-width: 8% !important;
  }

  .col-2, .col-sm-2, .col-md-2, .col-lg-2,
  [class*=col-sm-].col-md-2,
  [class*=col-].col-md-2,
  [class*=col-md-].col-lg-2,
  [class*=col-].col-lg-2,
  [class*=col-sm-][class*=col-md-].col-lg-2 {
    flex: 0 0 16%;
    max-width: 16%;
  }

  .col-3, .col-sm-3, .col-md-3, .col-lg-3,
  [class*=col-sm-].col-md-3,
  [class*=col-].col-md-3,
  [class*=col-md-].col-lg-3,
  [class*=col-].col-lg-3,
  [class*=col-sm-][class*=col-md-].col-lg-3 {
    flex: 0 0 24%;
    max-width: 24%;
  }

  .col-4, .col-sm-4, .col-md-4, .col-lg-4,
  [class*=col-sm-].col-md-4,
  [class*=col-].col-md-4,
  [class*=col-md-].col-lg-4,
  [class*=col-].col-lg-4,
  [class*=col-sm-][class*=col-md-].col-lg-4 {
    flex: 0 0 32%;
    max-width: 32%;
  }

  .col-5, .col-sm-5, .col-md-5, .col-lg-5,
  [class*=col-sm-].col-md-5,
  [class*=col-].col-md-5,
  [class*=col-md-].col-lg-5,
  [class*=col-].col-lg-5,
  [class*=col-sm-][class*=col-md-].col-lg-5 {
    flex: 0 0 40%;
    max-width: 40%;
  }

  .col-6, .col-sm-6, .col-md-6, .col-lg-6,
  [class*=col-sm-].col-md-6,
  [class*=col-].col-md-6,
  [class*=col-md-].col-lg-6,
  [class*=col-].col-lg-6,
  [class*=col-sm-][class*=col-md-].col-lg-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }

  .col-8, .col-sm-8, .col-md-8, .col-lg-8,
  [class*=col-sm-].col-md-8,
  [class*=col-].col-md-8,
  [class*=col-md-].col-lg-8,
  [class*=col-].col-lg-8,
  [class*=col-sm-][class*=col-md-].col-lg-8 {
    flex: 0 0 64%;
    max-width: 64%;
  }

  .col-9, .col-sm-9, .col-md-9, .col-lg-9,
  [class*=col-sm-].col-md-9,
  [class*=col-].col-md-9,
  [class*=col-md-].col-lg-9,
  [class*=col-].col-lg-9,
  [class*=col-sm-][class*=col-md-].col-lg-9 {
    flex: 0 0 72%;
    max-width: 72%;
  }

  .col-10, .col-sm-10, .col-md-10, .col-lg-10,
  [class*=col-sm-].col-md-10,
  [class*=col-].col-md-10,
  [class*=col-md-].col-lg-10,
  [class*=col-].col-lg-10,
  [class*=col-sm-][class*=col-md-].col-lg-10 {
    flex: 0 0 80%;
    max-width: 80%;
  }

  .col-11, .col-sm-11, .col-md-11, .col-lg-11,
  [class*=col-sm-].col-md-11,
  [class*=col-].col-md-11,
  [class*=col-md-].col-lg-11,
  [class*=col-].col-lg-11,
  [class*=col-sm-][class*=col-md-].col-lg-11 {
    flex: 0 0 88%;
    max-width: 88%;
  }

  .col-12, .col-sm-12, .col-md-12, .col-lg-12,
  [class*=col-sm-].col-md-12,
  [class*=col-].col-md-12,
  [class*=col-md-].col-lg-12,
  [class*=col-].col-lg-12,
  [class*=col-sm-][class*=col-md-].col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .col.pdf-reactor-8,
  .col-sm.pdf-reactor-8,
  .col-md.pdf-reactor-8,
  .col-lg.pdf-reactor-8 {
    flex: 0 0 12% !important;
    max-width: 12% !important;
  }

  .pdf-reactor-8-percent {
    flex: 0 0 8% !important;
    max-width: 8% !important;
  }

  .pdf-reactor-13-percent {
    flex: 0 0 13.3% !important;
    max-width: 13.3% !important;
  }
  
  .pdf-reactor-left-pad-1 {
    padding-left: 1.375rem;
  }

  .pdf-18-percent {
    flex: 0 0 18% !important;
    max-width: 18% !important;
  }

  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: 0;
    margin-left: 0;
  }

  .text-break {
    word-break: break-word !important;
    overflow-wrap: break-word !important;
  }

  div.credit-report .report-complete-msg {
    border-bottom: solid 1px;
    margin-bottom: 10px;
  }

  div.credit-report h2 {
    padding-top: 20px;
  }

  div.credit-report {
  }

  div.credit-freeze-msg {
    padding-top: 2rem;
  }

  h1, h2, h3, h4, div.h3 {
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 0.5rem;
    margin-top: 0;
  }

  h1:not(.content-main-title) {
    border-bottom: 1px dotted #939393;
  }

  h1 {
    color: #0295be;
    font-size: 1.5rem;
    line-height: 40px;
    margin-bottom: 2rem;
  }

  h2 {
    color: #0080a8;
    font-size: 1.2em;
    border-bottom: none;
    display: flex;
    flex-direction: row;
  }

  h2:before {
    margin-right: 0.5rem !important;
    padding-left: 5rem;
  }

  h2:after {
    flex: 1 1;
    margin-left: 0.5rem !important;
  }

  h2:before, h2:after {
    content: "";
    border-bottom: 1px solid #939393;
    margin: auto;
  }

  .ifs-report h2 {
    padding-top: 1.25rem;
  }

  h3, h4, div.h3 {
    font-size: 0.75rem;
  }

  .logo-appcard {
    padding-bottom: 2rem;
  }
    
  div.center-message {
    text-align: center;
  }
`;
